export default "__VITE_ASSET__C5Dm5exu__"